export const IBSHEET_BASEURL = '<IBSHEET_BASE_URL>'
